import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { FormSelect } from "@/components/form";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { DocFieldControl } from "./doc-field-control";
/** Document-kind dropdown selector that reveals the selected kind's fields below. */
export function DocAccordions(_ref) {
  var _typeSelector$options, _selected$fields;
  var config = _ref.config,
    formData = _ref.formData,
    onFieldChange = _ref.onFieldChange,
    expanded = _ref.expanded,
    onExpand = _ref.onExpand,
    workspaceId = _ref.workspaceId,
    patientId = _ref.patientId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var typeSelector = config.fields.find(function (field) {
    return field.type === "type_selector";
  });
  var options = ((_typeSelector$options = typeSelector === null || typeSelector === void 0 ? void 0 : typeSelector.options) !== null && _typeSelector$options !== void 0 ? _typeSelector$options : []).filter(function (option) {
    return option.enabled;
  });
  if (!options.length) return null;
  var selected = options.find(function (option) {
    return option.value === expanded;
  });
  var fields = ((_selected$fields = selected === null || selected === void 0 ? void 0 : selected.fields) !== null && _selected$fields !== void 0 ? _selected$fields : []).filter(function (field) {
    return field.type !== "dynamic" && field.type !== "type_selector";
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement(FormSelect, {
    label: typeSelector === null || typeSelector === void 0 ? void 0 : typeSelector.label,
    placeholder: t("select_document_type", {
      defaultValue: "Select document type"
    }),
    data: options.map(function (option) {
      return {
        value: option.value,
        label: option.label
      };
    }),
    value: expanded,
    onChange: function onChange(value) {
      trackEvent(ANALYTICS_EVENTS.DOC_ACCORDION, {
        docKind: value !== null && value !== void 0 ? value : ""
      });
      onExpand(value !== null && value !== void 0 ? value : null);
    },
    clearable: true,
    withinPortal: true,
    "data-testid": "doc-type-select"
  }), selected ? /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, fields.map(function (field) {
    var _formData$fieldKey, _formData;
    var fieldKey = "".concat(selected.value, ".").concat(field.name);
    return /*#__PURE__*/React.createElement(DocFieldControl, {
      key: field.name,
      field: field,
      fieldKey: fieldKey,
      value: (_formData$fieldKey = formData[fieldKey]) !== null && _formData$fieldKey !== void 0 ? _formData$fieldKey : "",
      valueName: (_formData = formData["".concat(fieldKey, "__name")]) !== null && _formData !== void 0 ? _formData : "",
      dropdowns: config.dropdowns,
      setField: onFieldChange,
      workspaceId: workspaceId,
      patientId: patientId
    });
  })) : null);
}